import React from 'react'
import ReactDOM from 'react-dom'
import ProjectDocuments from './ProjectDocuments'

document.addEventListener('DOMContentLoaded', () => {
  const projectDocumentsElement = document.getElementById('project-documents')
  const projectDocumentsData    = (projectDocumentsElement ? JSON.parse(projectDocumentsElement.getAttribute('data-project-documents')) : {})

  if (projectDocumentsElement && projectDocumentsData) {
    ReactDOM.render(
      <ProjectDocuments projectDocumentsData={projectDocumentsData} />,
      projectDocumentsElement
    )
  }
})



// WEBPACK FOOTER //
// ./app/frontend/packs/ProjectDocuments/index.jsx